<big-ui-card
    [hasLink]="!!data.link"
    [hasShadow]="hasShadow">
    <div
        *transloco="let t; prefix: 'uiCard'"
        class="flex items-center justify-center p-8 text-center"
        [ngClass]="classList">
        <span [ngClass]="{ 'group-hover/item:fill-primary-light': data.link }">
            @if (data.svgIcon) {
                <big-ui-svg-icon
                    [url]="data.svgIcon"
                    class="mb-4"
                    [ngClass]="iconSvgCssClass" />
            } @else if (data.icon) {
                <big-icon
                    [icon]="data.icon"
                    [size]="iconSize"
                    class="mb-4"
                    [ngClass]="iconCssClass" />
            }
        </span>

        <h4
            class="inline-block mb-4 last:grow last:mb-0"
            [ngClass]="{
                'group-hover/item:text-primary-light': data.link,
                'nth-last-2:mb-0': !!data.link && hideLink,
            }">
            {{ data.title }}
        </h4>
        @if (data.text) {
            <p
                class="mb-4 tracking-wide grow last:mb-0"
                [ngClass]="{
                    'nth-last-2:mb-0': !!data.link && hideLink
                }"
                [innerHTML]="data.text | nl2br | sanitize: securityContext"></p>
        }
        @if (data.link) {
            <big-ui-link
                class="text-primary hover:text-primary-light"
                [href]="data.link.href"
                [linkClass]="'tracking-wide font-bold no-underline after:absolute after:inset-0'">
                <span
                    class="flex items-center translate-y-[1px]"
                    [ngClass]="{ 'sr-only': hideLink }">
                    @if (data.link.title) {
                        {{ data.link.title }}
                    } @else {
                        {{ t('readMore') }}
                    }
                    <big-icon
                        class="mx-2 fill-current shrink-0"
                        [size]="'w-4'"
                        [icon]="iconArrowRight" />
                </span>
            </big-ui-link>
        }
    </div>
</big-ui-card>
